<template>
    <SettingsSection cssClass="profile-language-settings">
        <template #title>
            <h2>{{$t('views.profile.language_settings_title')}}</h2>
        </template>

        <template #content>
            <LanguageSwitch :includeText="true" />
        </template>
    </SettingsSection>
</template>

<script>
    import SettingsSection from '@/components/profile/Section';
    import LanguageSwitch from '@/components/misc/LanguageSwitch';
    
    export default {
        name: 'ProfileLanguageSettings',
        components: {
            SettingsSection,
            LanguageSwitch
        }
    }
</script>